import React, { useState } from 'react';
import axios from '../api';
import { useHistory } from 'react-router-dom';
import TransaccionalTabla from '../Transaccional/TransaccionalTabla';
import CierreDiaFiltroForm from './CierreDiaFiltroForm';
import './CierreDia.css';

const CierreDiaContainer = () => {
  const [transaccionalData, setTransaccionalData] = useState([]);

  const [filtros, setFiltros] = useState({
    codTerminal: "",
    codPark: "",
    numFactura: "",
  });
  const [liberarFiltros, setLiberarFiltros] = useState({
    cod_park: "",
    terminal: "",
    numero_factura: "",
    valorDescuento: "",
  });
  const [liberando, setLiberando] = useState(false);
  const [resultadoLiberacion, setResultadoLiberacion] = useState(null);
  const history = useHistory();

  const handleFiltroChange = (e) => {
    const { name, value } = e.target;
    setFiltros((prev) => ({ ...prev, [name]: value }));
  };

  const handleLiberarFiltroChange = (e) => {
    const { name, value } = e.target;
    setLiberarFiltros((prev) => ({ ...prev, [name]: value }));
  };

  const handleLiberarFactura = async (e) => {
    e.preventDefault();
    const { cod_park, terminal, numero_factura, valorDescuento } = liberarFiltros;
    // Iteraciones ahora siempre será 0 por defecto
    const iterNum = 0;

    if (!cod_park || !terminal || !numero_factura || valorDescuento === "") {
      alert("Por favor complete todos los campos: código parqueadero, terminal, número de factura y valor descuento.");
      return;
    }
    const valorNum = parseFloat(valorDescuento);
    if (isNaN(valorNum)) {
      alert("Valor descuento debe ser numérico.");
      return;
    }
    setLiberando(true);
    try {
      const response = await axios.post("/transaccional/liberar-factura", {
        cod_park,
        terminal,
        numero_factura,
        valorDescuento: valorNum,
        iteraciones: iterNum,
      });

      const payload = response?.data;
      const ok = typeof payload?.ok === "boolean" ? payload.ok : true;
      const message = payload?.message || "Respuesta recibida de la BD.";
      const dbResponse = payload?.dbResponse !== undefined ? payload.dbResponse : payload;

      setResultadoLiberacion({
        ok,
        message,
        dbResponse,
      });

      alert(`${ok ? "Liberacion procesada" : "Liberacion sin confirmacion de filas"}.\n${message}`);
      setLiberarFiltros({ cod_park: "", terminal: "", numero_factura: "", valorDescuento: "" });
    } catch (error) {
      console.error("Error al liberar factura:", error);
      const errorMessage = error.response?.data?.message || error.message || "Error al liberar factura.";
      setResultadoLiberacion({
        ok: false,
        message: errorMessage,
        dbResponse: error.response?.data ?? null,
      });
      alert(errorMessage);
    } finally {
      setLiberando(false);
    }
  };

  const buscarCierres = async (e) => {
    e.preventDefault();
    const { codTerminal, codPark, numFactura } = filtros;
    if (!codTerminal || !codPark || !numFactura) {
      alert("Por favor complete todos los campos de búsqueda (terminal, parqueadero y número de factura)");
      return;
    }
    try {
      const response = await axios.post("/transaccional/buscar-por-body", {
        codTerminal,
        codPark,
        numFactura,
      });
      const rows = response.data;
      setTransaccionalData(rows);
      const first = Array.isArray(rows) && rows.length > 0 ? rows[0] : null;
      if (first) {
        const numFac =
          first.num_factura != null && first.num_factura !== ""
            ? String(first.num_factura)
            : String(numFactura ?? "");
        setLiberarFiltros((prev) => ({
          ...prev,
          cod_park: first.codPark != null ? String(first.codPark) : prev.cod_park,
          terminal: first.codTerminal != null ? String(first.codTerminal) : prev.terminal,
          numero_factura: numFac,
        }));
      }
    } catch (error) {
      console.error('Error al buscar:', error);
      alert(error.response?.data?.message || error.message || "Error al buscar.");
    }
  };

  const handleLimpiar = () => {
    setFiltros({ codTerminal: "", codPark: "", numFactura: "" });
    setTransaccionalData([]);
  };

  const handleLimpiarLiberar = () => {
    setLiberarFiltros({ cod_park: "", terminal: "", numero_factura: "", valorDescuento: "" });
    setResultadoLiberacion(null);
  };

  const handleVolverHome = () => {
    history.push('/Planillas');
  };

  return (
    <div className="cierre-turno-container">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h2 className="cierre-turno-title">Liberar factura</h2>
        <button 
          onClick={handleVolverHome}
          style={{
            padding: '10px 20px',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: 'bold'
          }}
          onMouseOver={(e) => e.target.style.backgroundColor = '#0056b3'}
          onMouseOut={(e) => e.target.style.backgroundColor = '#007bff'}
        >
          ← Volver al Home
        </button>
      </div>

      <CierreDiaFiltroForm
        filtros={filtros}
        onChange={handleFiltroChange}
        onSubmit={buscarCierres}
        onClear={handleLimpiar}
        liberarFiltros={liberarFiltros}
        onLiberarFiltroChange={handleLiberarFiltroChange}
        onLiberarFactura={handleLiberarFactura}
        onClearLiberar={handleLimpiarLiberar}
        liberando={liberando}
      />

      {resultadoLiberacion && (
        <div
          style={{
            marginTop: "20px",
            padding: "12px",
            borderRadius: "8px",
            border: `1px solid ${resultadoLiberacion.ok ? "#2e7d32" : "#c62828"}`,
            backgroundColor: resultadoLiberacion.ok ? "#e8f5e9" : "#ffebee",
          }}
        >
          <h3 style={{ marginTop: 0, marginBottom: "8px" }}>
            {resultadoLiberacion.ok ? "Resultado liberacion: OK" : "Resultado liberacion: con observaciones/error"}
          </h3>
          <p style={{ marginTop: 0 }}>{resultadoLiberacion.message}</p>
          <pre
            style={{
              margin: 0,
              padding: "10px",
              backgroundColor: "#f5f5f5",
              borderRadius: "6px",
              overflowX: "auto",
              maxHeight: "260px",
            }}
          >
            {JSON.stringify(resultadoLiberacion.dbResponse, null, 2)}
          </pre>
        </div>
      )}

      {transaccionalData.length > 0 && (
        <div className="table-container">
          <h3>Resultados</h3>
          <TransaccionalTabla
            transacciones={transaccionalData}
          />
        </div>
      )}
    </div>
  );
};

export default CierreDiaContainer; 